// json web token
// eslint-disable-next-line camelcase
// import jwt_decode from "jwt-decode";

// eslint-disable-next-line import/prefer-default-export
export const formData = (fields) => {
  // const isAdmin =
  //   localStorage.getItem("token") &&
  //   jwt_decode(localStorage.getItem("token")).roles.includes("ROLE_ADMIN");
  const data = new FormData();
  Object.keys(fields).forEach((field) => {
    if (field === "users") {
      // console.log(field);
      // console.log("valeur =>");
      // console.log(fields[field].value);
      data.append(
        field,
        fields[field].value.map((user) => user.slice(0, user.lastIndexOf("/")))
      );
    } else if (field === "clients") {
      // console.log(field);
      // console.log("valeur =>");
      // console.log(fields[field].value);
      data.append(
        field,
        fields[field].value.map((user) => user.slice(0, user.lastIndexOf("/")))
      );
    } else if (field !== "imageFile") {
      // console.log(field);
      // console.log("valeur =>");
      // console.log(fields[field].value);

      data.append(field, fields[field].value.toString());
    } else if (fields[field].value !== null) {
      // console.log(field);
      // console.log("valeur =>");
      // console.log(fields[field].value);

      data.append(field, fields[field].value);
    }
  });
  data.set("course", fields.course.value.slice(0, fields.course.value.lastIndexOf("/")));

  return data;
};

export const statusData = (fields) => {
  const data = new FormData();
  Object.keys(fields).forEach((field) => {
    data.append(field, fields[field]);
  });

  return data;
};
